import { Action, ActionCreator, Dispatch } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { IApplicationState } from '../store'
import { IResponseAction } from '../interfaces'
import GlnService from '../../../shared/service/GlnService'
import { IKlantAfleverafspraak } from 'shared/models/IKlantAfleverafspraak'

export enum Actions {
  ClearDataResponse = 'ClearDataResponse',
  GetAfleverafsprakenDataRequest = 'GetAfleverafsprakenDataRequest',
  GetAfleverafsprakenDataResponse = 'GetAfleverafsprakenDataResponse',
}

export interface IClearDataResponseAction
  extends Action<Actions.ClearDataResponse> {
  payload: string
}
export interface IGetAfleverafsprakenDataRequestAction
  extends Action<Actions.GetAfleverafsprakenDataRequest> {}
export interface IGetAfleverafsprakenDataResponseAction
  extends IResponseAction<Actions.GetAfleverafsprakenDataResponse> {
  payload: IKlantAfleverafspraak[]
}

export type ZonderLocatieActions =
  | IClearDataResponseAction
  | IGetAfleverafsprakenDataRequestAction
  | IGetAfleverafsprakenDataResponseAction

export const getAfleverafsprakenCreator: ActionCreator<
  ThunkAction<
    Promise<IGetAfleverafsprakenDataResponseAction>,
    IApplicationState,
    null,
    IGetAfleverafsprakenDataResponseAction
  >
> = () => {
  return async (dispatch: Dispatch, getState) => {
    const requestDataAction: IGetAfleverafsprakenDataRequestAction = {
      type: Actions.GetAfleverafsprakenDataRequest,
    }
    dispatch(requestDataAction)
    try {
      const result = await GlnService.getAfleverafsprakenZonderLocatie()
      const response: IGetAfleverafsprakenDataResponseAction = {
        success: result.success,
        errorMessage: result.errorMessage,
        payload: result.payLoad,
        type: Actions.GetAfleverafsprakenDataResponse,
      }

      if (result.success && result.payLoad.length === 0) {
        response.success = false
        response.errorMessage = 'Geen afleverafspraken zonder locatie gevonden'
      }

      return dispatch(response)
    } catch (e) {
      const errorResponse: IGetAfleverafsprakenDataResponseAction = {
        success: false,
        errorMessage: `Fout bij ophalen afleverafspraken: ${e.message}`,
        payload: null,
        type: Actions.GetAfleverafsprakenDataResponse,
      }
      return dispatch(errorResponse)
    }
  }
}

export const clearDataActionCreator: ActionCreator<
  ThunkAction<
    Promise<IClearDataResponseAction>,
    IApplicationState,
    null,
    IClearDataResponseAction
  >
> = (message: string) => {
  return async (dispatch: Dispatch, getState) => {
    const clearResponse: IClearDataResponseAction = {
      type: Actions.ClearDataResponse,
      payload: message,
    }
    return dispatch(clearResponse)
  }
}
